<div class="page-layout flex-vertical gap-32 align-self-stretch">
  <div class="flex-horizontal width-100pc">
    <h4 class="flex-none">Opérations</h4>
    <div class="flex-1"></div>
    @if (userBackOfficeInfo?.withGroupeAccessExtended) {
      <oui-button-toggle
        [control]="serviceToggleControl"
      [options]="serviceToggleOptions"></oui-button-toggle>
    }
  </div>

  <oui-tab-group class="tabs" [selectedIndex]="tabIndex" (selectedIndexChange)="onTabIndexChange($event)">
    <oui-tab [label]="'Toutes ' + allItemNumber">
      @if (isTabLoaded(0)) {
        <app-operation-dashboard
          [columnSelection]="columnSelection"
          [allowedActions]="allowedActions"
          [filterSelection]="filterSelection"
          [defaultQueryFilter]="allDefaultQueryFilter"
          [noFetch]="noFetch"
          [refreshFromNetworkOnLoad]="refreshFromNetworkOnLoad"
          (onTotalCount)="updateAllItemNumber($event)"
          (onSelectedOperation)="onOperationClick($event)"
          [withCSVExport]="true"
          [dashboardKey]="'all-operations'">
        </app-operation-dashboard>
      }
    </oui-tab>
    <oui-tab [label]="'Attente originaux ' + waitingDocumentsItemNumber">
      @if (isTabLoaded(1)) {
        <app-operation-dashboard
          [columnSelection]="columnSelection"
          [allowedActions]="allowedActions"
          [filterSelection]="filterSelection"
          [defaultQueryFilter]="waitingDocumentsDefaultQueryFilter"
          [noFetch]="noFetch"
          [refreshFromNetworkOnLoad]="refreshFromNetworkOnLoad"
          (onTotalCount)="updateWaitingDocumentsItemNumber($event)"
          (onSelectedOperation)="onOperationClick($event)"
          [withCSVExport]="true"
          [dashboardKey]="'attente-originaux'">
        </app-operation-dashboard>
      }
    </oui-tab>
    <oui-tab [label]="'Demandes PM ' + demandesPmItemNumber">
      @if (isTabLoaded(2)) {
        <lib-creation-personne-morale-dashboard
          [columnSelection]="creationPMColumnSelection"
          config="backoffice"
          (onTotalCount)="updateDemandesPmItemNumber($event)">
        </lib-creation-personne-morale-dashboard>
      }
    </oui-tab>
    <oui-tab [label]="'A affecter ' + toDispatchItemNumber">
      @if (isTabLoaded(3)) {
        <app-operation-dashboard
          [columnSelection]="columnSelection"
          [allowedActions]="allowedActions"
          [filterSelection]="filterSelection"
          [defaultQueryFilter]="toDispatchDefaultQueryFilter"
          [withSelects]="authService.isAdminRole()"
          (onSelectedOperation)="onOperationClick($event)"
          (onDispatchedOperationsEvent)="refreshToControlOperationsBoard()"
          [noFetch]="noFetch"
          [refreshFromNetworkOnLoad]="refreshFromNetworkOnLoad"
          (onTotalCount)="updateToDispatchItemNumber($event)"
          [withCSVExport]="true"
        [dashboardKey]="'a-affecter'"></app-operation-dashboard>
      }
    </oui-tab>
    <oui-tab [label]="'Contrôles à effectuer ' + toControlItemNumber">
      @if (isTabLoaded(4)) {
        <app-operation-dashboard
          #toControlBoard
          [columnSelection]="columnSelection"
          [allowedActions]="allowedActions"
          [filterSelection]="filterSelection"
          [defaultQueryFilter]="toControlDefaultQueryFilter"
          (onSelectedOperation)="onOperationClick($event)"
          [noFetch]="noFetch"
          [refreshFromNetworkOnLoad]="refreshFromNetworkOnLoad"
          [withSelects]="authService.isAdminRole()"
          (onTotalCount)="updateToControlItemNumber($event)"
          [preSelectedGestionnaireId]="authService.userInfo.id"
          [withCSVExport]="true"
        [dashboardKey]="'control-a-effectuer'"></app-operation-dashboard>
      }
    </oui-tab>
    <oui-tab [label]="'En attente de retour ' + waitingReturnItemNumber">
      @if (isTabLoaded(5)) {
        <app-operation-dashboard
          [columnSelection]="columnSelection"
          [allowedActions]="allowedActions"
          [filterSelection]="filterSelection"
          (onSelectedOperation)="onOperationClick($event)"
          [defaultQueryFilter]="waitingReturnDefaultQueryFilter"
          [noFetch]="noFetch"
          [refreshFromNetworkOnLoad]="refreshFromNetworkOnLoad"
          [withSelects]="authService.isAdminRole()"
          (onTotalCount)="updateWaitingReturnItemNumber($event)"
          [preSelectedGestionnaireId]="authService.userInfo.id"
          [withCSVExport]="true"
        [dashboardKey]="'en-attente-de-retour'"></app-operation-dashboard>
      }
    </oui-tab>
    <oui-tab [label]="'Historique ' + historyItemNumber">
      @if (isTabLoaded(6)) {
        <app-operation-dashboard
          [columnSelection]="columnSelection"
          [allowedActions]="allowedActions"
          [filterSelection]="filterSelection"
          (onSelectedOperation)="onOperationClick($event)"
          [noFetch]="noFetch"
          [refreshFromNetworkOnLoad]="refreshFromNetworkOnLoad"
          (onTotalCount)="updateHistoryItemNumber($event)"
          [defaultQueryFilter]="historiqueDefaultQueryFilter"
          [withCSVExport]="true"
        [dashboardKey]="'historique'"></app-operation-dashboard>
      }
    </oui-tab>
  </oui-tab-group>
</div>
